import { createSelector } from 'reselect';

const selectStops = (state: any) => state.stops;


export const selectStopsCurrentItem = createSelector([selectStops], (stops) => stops.current);

export const selectStopsListItems = createSelector([selectStops], (stops) => stops.list);

export const selectStopsItemById = (itemId: any) =>
    createSelector(selectStopsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectStopsQueryItems = createSelector([selectStops], (stops) => stops.query);

export const selectStopsCreatedItem = createSelector([selectStops], (stops) => stops.create);

export const selectStopsUpdatedItem = createSelector([selectStops], (stops) => stops.update);

export const selectStopsReadItem = createSelector([selectStops], (stops) => stops.read);

export const selectStopsDeletedItem = createSelector([selectStops], (stops) => stops.delete);

export const selectStopsSearchedItems = createSelector([selectStops], (stops) => stops.search);

export const selectStopsItemsCount = createSelector([selectStops], (stops) => stops.count);

export const selectStopsItemsFilter = createSelector([selectStops], (stops) => stops.filter);